import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';

const EditProfile = () => {
    
    const navigate = useNavigate();
    const authData = useSelector(state => state.authState);
    const [editMode, setEditMode] = useState(false);  
    const [userDetail, setUserDetail] = useState({});

    const [erroruserDetail, setErroruserDetail] = useState({})

    const onChangeHandle = (e) => {
        //console.log("run the function for chnag the valeie")
        const { name, value, type } = e.target;

        setUserDetail((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validationUserDetail = () => {

        const errors = {};

        if (!userDetail.user_name) {
            errors.user_name = "Name is required";
        }

        if (!userDetail.user_mobile) {
            errors.user_mobile = "Mobile is required";
        } else if (!/^\d{10}$/.test(userDetail.user_mobile)) {
            errors.user_mobile = "Mobile number must be 10 digits";
        }

        setErroruserDetail(errors);

        // Return true if there are no errors
        return Object.keys(errors).length === 0;
    }

    const UpdateUserDetail = async () => {

        let validation = await validationUserDetail()
        if (!validation) {
            return
        }

        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`/api/admin/User_Detail/Edit_User`, userDetail, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                // setUserDetail(response.user_Detail)
                setEditMode(false);
                // setEditMode(false)
            }
            else {
                setEditMode(false);
                console.log("update successfully");
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    }

    
    const handleEditModeToggle = () => {
        setEditMode(!editMode);
    };
    
    return(
        <>
            <section className="user-dashboard-section section-b-space">
                    <div className="container-fluid-lg">
                        <div className="row">
                            <div className="col-xxl-12 col-lg-12">  
                            <div className="dashboard-profile">
                                            <div className="title">
                                                <h2>My Profile</h2>
                                                <span className="title-leaf">
                                                    <svg className="icon-width bg-gray">
                                                        <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                    </svg>
                                                </span>
                                            </div>
                                            {/* <div className="profile-detail dashboard-bg-box">
                                                <div className="dashboard-title">
                                                    <h3>Profile Name</h3>
                                                </div>
                                                <div className="profile-name-detail">
                                                    <div className="d-sm-flex align-items-center d-block">
                                                        <h3>{userDetail.user_name}</h3>
                                                    </div>
                                                    <a
                                                        href="javascript:void(0)"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#editProfile"
                                                    >
                                                        Edit
                                                    </a>
                                                </div>
                                                {/* <div className="location-profile">
                                                    <ul>
                                                        <li>
                                                            <div className="location-box">
                                                                <i data-feather="map-pin" />
                                                                <h6>Downers Grove, IL</h6>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="location-box">
                                                                <i data-feather="mail" />
                                                                <h6>vicki.pope@gmail.com</h6>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="location-box">
                                                                <i data-feather="check-square" />
                                                                <h6>Licensed for 2 years</h6>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="profile-description">
                                                    <p>
                                                        Residences can be classified by and how they are
                                                        connected to neighbouring residences and land. Different
                                                        types of housing tenure can be used for the same
                                                        physical type.
                                                    </p>
                                                </div> */}
                                            {/* </div> */}
                                            <div className="profile-about dashboard-bg-box">
                                                <div className="row">
                                                    <div className="col-xxl-7">
                                                        {/* <div className="dashboard-title mb-3">
                                                            <h3>Profile About</h3>
                                                        </div> */}
                                                        <div className="table-responsive">
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Name :</td>
                                                                        <input
                                                                            type='text'
                                                                            disabled={!editMode}
                                                                            style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                            value={userDetail.user_name}
                                                                            id="user_name"
                                                                            name='user_name'
                                                                            onChange={onChangeHandle} // Corrected from onchange to onChange
                                                                        />
                                                                        {erroruserDetail.user_name && <div className="text-danger">{erroruserDetail.user_name}</div>}

                                                                        {/* <td>{userDetail.user_name}</td> */}
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td>Gender :</td>
                                                                        <td>{userDetail.user_name}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Birthday :</td>
                                                                        <td>21/05/1997</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td>Phone Number :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                {" "}
                                                                                <input type='text'
                                                                                    disabled={!editMode}
                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                    value={userDetail.user_mobile}
                                                                                    id="user_mobile"
                                                                                    name='user_mobile'
                                                                                    onChange={onChangeHandle}
                                                                                />
                                                                                {erroruserDetail.user_mobile && <div className="text-danger">{erroruserDetail.user_mobile}</div>}
                                                                                {/* {userDetail.user_mobile} */}
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td>Address :</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td>Email :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                <input type='text'
                                                                                    // disabled={!editMode}
                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                    value={userDetail.user_email}
                                                                                    id="user_email"
                                                                                    name='user_email'
                                                                                    onChange={onChangeHandle}
                                                                                    disabled={true}
                                                                                />
                                                                                {/* {userDetail.user_email} */}
                                                                                <span onClick={editMode ? UpdateUserDetail : handleEditModeToggle}>
                                                                                    {editMode ? 'Save' : 'Edit'}
                                                                                </span>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        {/* <div className="dashboard-title mb-3">
                                                            <h3>Login Details</h3>
                                                        </div> */}
                                                        {/* <div className="table-responsive">
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Email :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                vicki.pope@gmail.com
                                                                                <span
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#editProfile"
                                                                                >
                                                                                    Edit
                                                                                </span>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Password :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                ●●●●●●
                                                                                <span
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#editProfile"
                                                                                >
                                                                                    Edit
                                                                                </span>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div> */}
                                                    </div>
                                                    <div className="col-xxl-5">
                                                        <div className="profile-image">
                                                            <img
                                                                src="../assets/images/inner-page/dashboard-profile.png"
                                                                className="img-fluid  lazyload"
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                            </div> 
                        </div>
                    </div>
            </section>
        </>)
}

export default EditProfile;